import { bool, func, object, string } from 'prop-types';
import React, { useMemo, useRef, useState } from 'react';
import { I18n } from 'utils/i18n';
import channelShape from 'shapes/channel';
import employeeShape from 'shapes/employee';
import ChatField from '../../controls/ChatField';
import ClipboardImageDialog from './ClipboardImageDialog';
import connector from './connector';

const FormikChatField = ({
  field,
  form,
  inputRef: inputRefProp = null,
  authEmployee = null,
  voicePlaceholder = null,
  ...props
}) => {
  const [isOpenDialog, setOpenDialog] = useState(false);
  const [file, setFile] = useState(null);
  const inputRef = useRef();

  const setInputRef = useMemo(() => {
    const result = elem => {
      inputRef.current = elem;
      if (typeof inputRefProp === 'function') {
        inputRefProp(elem);
      }
      if (typeof inputRefProp === 'object') {
        inputRefProp.current = elem;
      }
      result.current = elem;
    };
    return result;
  }, [inputRefProp]);

  const findSomePicture = clipboardItems => {
    const items = Array.from(clipboardItems);
    return items.find(item => item.type.includes('image'));
  };

  const openDialog = f => {
    setOpenDialog(true);
    setFile(f);
  };

  const closeDialog = () => {
    setOpenDialog(false);
    setFile(null);
  };

  const handlePaste = ({ clipboardData }) => {
    const hasHtml = !!clipboardData.getData('text/html');
    if (hasHtml) return;
    const f = findSomePicture(clipboardData.files);
    if (f) openDialog(f);
  };

  const saveAttachment = async attachment => {
    const { values, submitForm, setFieldValue } = form;

    await setFieldValue('attachments', [...values.attachments, attachment]);
    setTimeout(submitForm, 1);

    closeDialog();
  };

  const generatePlaceholder = sentAsChannel => {
    const { channel, isCompanyAdmin } = props;
    const name = sentAsChannel ? channel.name : authEmployee?.name;

    if (isCompanyAdmin)
      return `${I18n.t('SendMessageForm.Write message as')} ${name || 'Super admin'}`;

    return I18n.t('SendMessageForm.Write message or attach file');
  };

  const { name, value, onBlur, onChange } = field;
  const { values, handleSubmit } = form;

  return (
    <>
      <ChatField
        {...props}
        onPaste={handlePaste}
        onChange={onChange}
        onBlur={onBlur}
        onFormatStateChange={props.onFormatStateChange}
        onLinkShortcut={props.onLinkShortcut}
        onLinkEdit={props.onLinkEdit}
        placeholder={voicePlaceholder || generatePlaceholder(values.sentAsChannel)}
        onSend={handleSubmit}
        value={value}
        name={name}
        inputRef={setInputRef}
      />
      <ClipboardImageDialog
        isOpen={isOpenDialog}
        file={file}
        onConfirm={saveAttachment}
        onClose={closeDialog}
        channel={props.channel}
      />
    </>
  );
};

FormikChatField.propTypes = {
  suggestionsPortal: object.isRequired,
  field: object.isRequired,
  form: object.isRequired,
  isCompanyAdmin: bool.isRequired,
  authEmployee: employeeShape,
  channel: channelShape.isRequired,
  inputRef: object,
  voicePlaceholder: string,
  onLinkShortcut: func,
  onLinkEdit: func,
};
export default connector(FormikChatField);
